import { memo, useMemo } from "react";
import {
  AutoComplete,
  FormCheckBox,
  FormInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { TAutomationReceivedDaysAheadForm } from "../automationReceivedDaysAheadSchema";
import { useWatch } from "react-hook-form";
import { listMainGenerics } from "../../../../../../../../services/generic.service";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedDaysAhead.";

export const LimitFinalDate = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } =
    useFormContext<TAutomationReceivedDaysAheadForm>();

  const limitFinalDate = useWatch({
    control,
    name: "limitFinalDate",
  });

  const timeLimitType = useWatch({
    control,
    name: "timeLimitType",
  });

  const ticketLimitTypeParams = useMemo(() => {
    return {
      Identifier: "DaysAheadTimeLimitType",
    };
  }, []);

  return (
    <>
      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="limitFinalDate"
          label={t(translationPath + "limit_final_date") || "Limit Final Date"}
          onChangeCapture={() => {
            setValue("timeLimitType", null);
            setValue("limitMonths", null);
          }}
        />
      </Grid>

      {limitFinalDate && (
        <Grid item xs={12} sm={6}>
          <AutoComplete
            request={listMainGenerics}
            params={ticketLimitTypeParams}
            fullWidth
            name="timeLimitType"
            label={t(translationPath + "time_limit_type")}
            getOptionLabel={(option) => option.name}
            onValueChange={() => setValue("limitMonths", null)}
            size="small"
          />
        </Grid>
      )}

      {timeLimitType?.code === "2" && (
        <Grid item xs={12} sm={6}>
          <FormInput
            type="number"
            size="small"
            name="limitMonths"
            fullWidth
            label={t(translationPath + "limit_days")}
          />
        </Grid>
      )}
    </>
  );
});
